import { CoreButton } from "@komodo-design-system/komodo-components-react";
import React from "react";
import './BulkUploadContent.scss';
import { useNavigate } from "react-router";
import { HOME_PAGE } from "constants/routes";

interface ActionButtonProps {
  submitFile?: (e: React.MouseEvent<any>) => void;
  isDisabled: boolean;
  clearUploadData?: () => void;
  submitCheckIn?: (e: React.MouseEvent<any>) => void;
  isResetDisabled?: boolean
}

const ActionButton: React.FC<ActionButtonProps> = ({ submitFile, isDisabled, clearUploadData ,submitCheckIn, isResetDisabled}) => {
  const navigate = useNavigate();
  return (
    <div className="action-button">
      {submitFile &&  <CoreButton
        label="Submit"
        type="button"
        variant="primary"
        size="small"
        noradius="none"
        onClick={(e) => submitFile(e)}
        disabled={isDisabled}>
        Submit
      </CoreButton>}
      {submitCheckIn && <CoreButton
        label="Check In"
        type="button"
        variant="primary"
        size="small"
        noradius="none"
        onClick={(e) => submitCheckIn(e)}
        disabled={isDisabled}>
      </CoreButton>
      }
      {clearUploadData && <CoreButton
        label="Reset"
        type="button"
        variant="outline"
        size="small"
        noradius="none"
        disabled={isResetDisabled || false}
        onClick={() => clearUploadData()}>
      </CoreButton> }
      <CoreButton
        label="Cancel"
        type="button"
        variant="outline"
        size="small"
        noradius="none"
        onClick={() => navigate(HOME_PAGE)}>
      </CoreButton>


    </div>
  );
};

export default ActionButton;